/**
 * Pluralisation FR / EN — utilise Intl.PluralRules pour choisir "one" ou "other".
 *
 * Utilisation :
 *   plural(count, { one: "country.citiesOne", other: "country.citiesOther" }, lang)
 *   → renvoie la clé i18n adaptée.
 */

export type Lang = "fr" | "en";

const RULES: Record<Lang, Intl.PluralRules> = {
  fr: new Intl.PluralRules("fr-FR"),
  en: new Intl.PluralRules("en-US"),
};

export function pluralKey<T extends string>(
  count: number,
  keys: { one: T; other: T },
  lang: Lang,
): T {
  const rule = RULES[lang].select(count);
  return rule === "one" ? keys.one : keys.other;
}
